import { AlleGrunntyperMedDefault } from "../valideringstyper/grunntyper";

const default_validering: AlleGrunntyperMedDefault = {
  ikke: {
    null: "Must be filled out",
    blank: "Cannot consist of only blank characters",
    tom: "Cannot be empty",
    lik: {
      verdi: "Cannot be equal to {{messageParams.value}}",
    },
  },
  stoerre: {
    enn: "Must be greater than {{messageParams.value}}",
    eller: {
      lik: "Must be greater than or equal to {{messageParams.value}}",
    },
  },
  mindre: {
    eller: {
      lik: "Must be less than or equal to {{messageParams.value}}",
    },
  },
  mellom: "Must be between {{messageParams.min}} and {{messageParams.max}}",
  lik: "Must be equal to {{messageParams.value}}",
  min: {
    lengde: "Must be at least {{messageParams.minLength}}",
  },
  maks: {
    lengde: "Cannot be longer than {{messageParams.maxLength}}",
    size: "Cannot be larger than {{messageParams.maxSize}}",
  },
  true: "Invalid input",
  ugyldig: {
    moenster: "Invalid format",
  },
  en: {
    av: "Must be one of {{messageParams.values, generic_string_list_formatter}}",
  },
  filstoerrelse: {
    totalt:
      "Total file size must be less than {{messageParams.maksFilstoerrelseString}}",
  },
};
export default default_validering;
